module.exports = __webpack_public_path__ + "static/assets/f95ab98a0575873b73d358149fa4245a.png";